<template>
    <div ref="plist" class="priv-ellipsis-list" :class="{ 'show-ellipsis': showEllipsis }">
        <div v-for="(value, key, index) in priObj" :key="index" class="rolelstitem">
            <div style="display: inline-block; font-size: 16px;">{{ key }}</div>
            <div class="listItemValue">{{ value }}</div>
        </div>
        <p class="comma" :style="{ left: ellipsisLeft }">...</p>
    </div>
</template>
<script>
export default {
    components: {},
    props: {
        priObj: {
            type: Object,
            default: () => {}
        }
    },
    data() {
        return {
            maxWidth: 800,
            showEllipsis: false,
            ellipsisLeft: 'auto'
        };
    },

    mounted() {
        this.adjustEllipsis();
    },

    methods: {
        adjustEllipsis() {
            const $plist = this.$refs.plist;
            let itemList = [];
            let itemLineWidth = 0;

            if ($plist.clientHeight > 40) {
                this.showEllipsis = true;
            }

            if ($plist.querySelectorAll) {
                itemList = $plist.querySelectorAll('.rolelstitem');
                for (let i = 0; i < itemList.length; i++) {
                    const item = itemList[i];
                    itemLineWidth += item.scrollWidth;
                    if (itemLineWidth > 800) {
                        this.ellipsisLeft = `${itemLineWidth - item.scrollWidth}px`;
                        break;
                    }
                }
            }
        }
    }
};
</script>

<style lang="less">
@import './index.less';
</style>
